import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=fecbd3cc&scoped=true&"
import script from "./Trend.vue?vue&type=script&lang=ts&"
export * from "./Trend.vue?vue&type=script&lang=ts&"
import style0 from "./Trend.vue?vue&type=style&index=0&id=fecbd3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecbd3cc",
  null
  
)

export default component.exports